// extracted by mini-css-extract-plugin
export default {"centered":"styles_centered__TJXb2"};